import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import { DIP_STEPS } from '@/components/DipBreadcrumb';

const DipStepFooter = ({ productId, currentStep, nextLabel }) => {
  const navigate = useNavigate();
  const idx = DIP_STEPS.findIndex(s => s.key === currentStep);
  if (idx < 0) return null;

  const prev = idx > 0 ? DIP_STEPS[idx - 1] : null;
  const next = idx < DIP_STEPS.length - 1 ? DIP_STEPS[idx + 1] : null;

  const goTo = (route) => navigate(`/product/${productId}/${route}`);

  return (
    <div className="mt-8 pt-6 border-t border-border flex items-center justify-between gap-4 flex-wrap">
      {prev ? (
        <Button
          variant="outline"
          size="lg"
          onClick={() => goTo(prev.route)}
          data-testid="step-footer-prev"
          className="gap-2 h-12 px-6"
        >
          <ArrowLeft size={18} />
          {prev.label}
        </Button>
      ) : <div />}

      {next && (
        <Button
          size="lg"
          onClick={() => goTo(next.route)}
          data-testid="step-footer-next"
          className="gap-2 h-12 px-8 bg-[#205F79] hover:bg-[#184a5e] text-base font-semibold ml-auto"
        >
          {nextLabel || `Suivant : ${next.label}`}
          <ArrowRight size={18} />
        </Button>
      )}
    </div>
  );
};

export default DipStepFooter;
